module.exports = __webpack_public_path__ + "static/main-c322239876cdb5bc2984d8fa8dddf16a.png";